module.exports = __webpack_public_path__ + "img/banner-tc1.4e0d6433.jpg";